import React from 'react';
import { ChatHistoryPage } from '../../history/ChatHistoryPage';

export default function EnterpriseChatHistoryPage() {
  return <ChatHistoryPage />;
}
